module.exports = __webpack_public_path__ + "images/tabs/calendar-on.png";